import { all } from 'redux-saga/effects';
import serpSagas from '../Serp/sagas';
import adPageSagas from '../AdPage/sagas';
import indexSagas from '../Index/sagas';
import notificationsSagas from '../Notifications/sagas';
import suggestionsSagas from '../Suggestions/sagas';
import sourcesSagas from '../Sources/sagas';
import alertsSagas from '../Alerts/sagas';
import uiSagas from '../UI/sagas';
import featuredAdSagas from '../FeaturedAd/sagas';
import notificationsManagerEmailSagas from '../NotificationsManager/email/sagas';
import notificationsManagerWebPushSagas from '../NotificationsManager/webPush/sagas';
import notificationsManagerSettingsSagasModule from '../NotificationsManager/settings/sagas';
import feedbackSagas from '../CaptureFeedback/sagas';

// Single entry point to start all Sagas at once
export default function* rootSaga() {
  yield all([
    serpSagas(),
    adPageSagas(),
    indexSagas(),
    notificationsSagas(),
    alertsSagas(),
    suggestionsSagas(),
    sourcesSagas(),
    featuredAdSagas(),
    uiSagas(),
    notificationsManagerEmailSagas(),
    notificationsManagerWebPushSagas(),
    notificationsManagerSettingsSagasModule().sagas(),
    feedbackSagas(),
  ]);
}



// WEBPACK FOOTER //
// ./app/sagas/rootSaga.js